import React from "react";
import AdditionalDataSection from 'components/base/AdditionalData'

function TransactionAdditionalData({
  showTitle = false,
  additionalDataField = 'additionalData'
}) {
  return <AdditionalDataSection showTitle={showTitle} additionalDataField={additionalDataField} />
}

export default TransactionAdditionalData;